import { useCallback } from 'react';
import { UserService } from '../Services/UserService';
import { LAST_AUTHORISED_ORG_ID_KEY } from '../Utils/NavigationUtils';
import useConfiguration from './UseConfiguration';
import { useTokenData } from './UseTokenStore';
import useAuthenticatedFetchClient from './UseAuthenticatedFetchClient';
export function useLogout() {
    const configuration = useConfiguration();
    const { tokenData, setTokenData } = useTokenData();
    const fetchClient = useAuthenticatedFetchClient();
    const clearCredentials = useCallback(() => {
        localStorage.removeItem(LAST_AUTHORISED_ORG_ID_KEY);
        setTokenData(null);
    }, [setTokenData]);
    const clearCredentialsAndRedirectToLogout = useCallback(() => {
        const userService = new UserService(fetchClient, configuration.serviceConfig);
        const logoutUrl = userService.getAuthServiceLogoutUrl(tokenData?.id_token);
        clearCredentials();
        window.location.href = logoutUrl.toString();
    }, [fetchClient, clearCredentials, configuration.serviceConfig, tokenData]);
    return { clearCredentials, clearCredentialsAndRedirectToLogout };
}
//# sourceMappingURL=UseLogout.js.map